import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

import useTheme from "../hooks/useTheme";
import useWindowDimensions from "../hooks/useWindowDimensions";

export default function NoAppsInfo() {
  const theme = useTheme();
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();

  const styles: {
    container: React.CSSProperties;
    items: React.CSSProperties;
    note: React.CSSProperties;
  } = {
    container: {
      backgroundColor: theme.background,
      paddingTop: 15,
      paddingBottom: 15,
    },
    items: {
      justifyContent: "center",
    },
    note: {
      textAlign: "center",
      width: isSmallLayout || isMediumLayout ? "100%" : "80%",
    },
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: isSmallLayout || isMediumLayout ? "100%" : "80%",
          }}
        >
          <Grid2
            container
            alignItems="center"
            flexDirection={isSmallLayout || isMediumLayout ? "column" : "row"}
            justifyContent="center"
          >
            <h3
              style={{
                color: theme.textColor,
              }}
            >
              {"No Apps"}
            </h3>
          </Grid2>
        </div>
      </div>
    </div>
  );
}
